module.exports = __webpack_public_path__ + "img/pazarplus-business-card.7ac6c267.jpg";